'use client';

import { useEffect, useState } from 'react';
import { Dialog, DialogBackdrop, DialogPanel, TransitionChild } from '@headlessui/react';
import {
    Bars3Icon,
    CalendarIcon,
    DocumentDuplicateIcon,
    UsersIcon,
    XMarkIcon,
    UserIcon,
    CalendarDaysIcon,
    BellIcon,
    ArrowPathRoundedSquareIcon,
    Cog6ToothIcon,
    WalletIcon,
    ChartBarIcon,
    DocumentArrowUpIcon,
    PowerIcon,
    ClipboardDocumentCheckIcon,
    DocumentCheckIcon,
    CalendarDateRangeIcon,
    ChevronDoubleRightIcon,
    PlusCircleIcon,
    XCircleIcon,
    EyeDropperIcon,
    EyeIcon,
    PlusIcon,
    PencilIcon,
    Cog8ToothIcon,
    DocumentIcon,
    HomeIcon


} from '@heroicons/react/20/solid';
import { BookOpenIcon, ScaleIcon, UserGroupIcon } from '@heroicons/react/24/solid';
import { Link, useNavigate } from 'react-router-dom';
import { AnimatePresence, motion } from 'framer-motion';

import { AcademicCapIcon } from '@heroicons/react/20/solid';

import { ChatBubbleBottomCenterIcon } from '@heroicons/react/20/solid';
import { QuestionMarkCircleIcon } from '@heroicons/react/20/solid';
import { useContext } from 'react';
import { AuthContext } from '../AuthContext';

import { CheckCircleIcon } from '@heroicons/react/20/solid';
import SubstepCreator from './substepcreator';
import Viewsubsteps from './editsubsteps';
import Loading from './loading';
import {ProcessDocBuilder} from './processdocbuilder';
import CourseViewer from './courseviewer';
import RoleCalibration from './rolecalibration';






function classNames(...classes) {
    return classes.filter(Boolean).join(' ');
}

export default function Admin() {
    const [sidebarOpen, setSidebarOpen] = useState(false);
    const [openProcessForm, setOpenProcessForm] = useState(false);
    const [editOpenProcessForm, setEditOpenProcessForm] = useState(false);
    const [steps, setSteps] = useState([]);
    





    const navigate = useNavigate();

    const user = useContext(AuthContext);






    const navigation = [
        { name: 'Dashboard', href: '/dashboard', icon: HomeIcon, current: true },
        { name: 'Chat', href: '/chatdashboard', icon: ChatBubbleBottomCenterIcon, current: false },
        { name: 'My Profile', href: '/myprofile', icon: UserIcon, current: false },
        { name: 'Organization', href: '/organizationaltree', icon: ScaleIcon, current: false },
        { name: 'Task Manager', href: '/taskcalendar', icon: CalendarDateRangeIcon, current: false },
        { name: 'Admin Tasks', href: '/admin-tasks', icon: DocumentCheckIcon, current: false },
        { name: 'Training', href: '/training', icon: AcademicCapIcon, current: false },
        { name: 'Users', href: '/users', icon: UserGroupIcon, current: false },
        
        { name: 'Billing', href: '/billing', icon: WalletIcon, current: false },
        { name: 'Log Out', href: '/logout', icon: PowerIcon, current: false },

    ];




    const [processName, setProcessName] = useState('');
    const [processDescription, setProcessDescription] = useState('');
    const [directory, SetDirectory] = useState({});
    const [openSteps, setOpenSteps] = useState(false);
    const [nameProcess, setNameProcess] = useState('');
    const [openTaskForm, setOpenTaskForm] = useState(false);
const [taskName, setTaskName] = useState('');
const [taskDescription, setTaskDescription] = useState('');
const [stepNumber, setStepNumber] = useState('');
const [openSubstepViewer, setOpenSubstepViewer] = useState(false);
const [role, setRole] = useState('');
const [getRoles, setGetRoles] = useState([]);
const [processId, setProcessId] = useState('');
const [openSubStepsCreator, setOpenSubStepsCreator] = useState(false);
const [openEditTaskForm, setOpenEditTaskForm] = useState(false);
const [taskID, setTaskID] = useState('');
const [valueEngine, setValueEngine] = useState('growth');
const [showHelp, setShowHelp] = useState(false);
const [loading, setLoading] = useState(false);
const [openAiGenerate, setOpenAiGenerate] = useState(null);
const [trainingDocuments, setTrainingDocuments] = useState([]);
const [trainingFinished, setTrainingFinished] = useState(false);
const [openTrainingViewer, setOpenDoc] = useState(false);
const [processNames, setProcessNames] = useState('');
const [matchedProcess, setMatchedProcess] = useState([]);
const [unmatched, setUnmatched] = useState([]);
const [estimatedTime, setEstimatedTime] = useState('');
const [openRoleDropdown, setOpenRoleDropdown] = useState(null);
console.log(openAiGenerate);

    const handleSubmitNewProcess = async (e) => {

        e.preventDefault();

        const token = localStorage.getItem('token');

        const response = await fetch('https://api.insightos.co.uk/api/addprocess', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: 'include',
            body: JSON.stringify({
                process: processName,
                description: processDescription,
                valueEngine : valueEngine,
            }),
        });

        const data = await response.json();

        if (data.success) {
            console.log('Process created successfully');
            setOpenProcessForm(false);
            getProcess();
        }
    }

    const getProcess = async () => {
        const token = localStorage.getItem('token');

        const response = await fetch('https://api.insightos.co.uk/api/process', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: 'include',
        });

        const data = await response.json();



        if (data.success) {
            console.log('Processes:', data.data);


            // set the state to directory and turn into an object with the first letter of the Name as the key
            const directory = data.data.reduce((acc, person) => {
                const letter = person.Name[0].toUpperCase();
            
                if (!acc[letter]) {
                    acc[letter] = [];
                }
            
                acc[letter].push(person);
            
                // Sort alphabetically in ascending order
                acc[letter].sort((a, b) => a.Name.localeCompare(b.Name));
            
                return acc;
            }, {});
            
            console.log('Directory:', directory);

setProcessNames(data.data.map(item => item.Name));
            SetDirectory(directory);


        }

        // catch any errors

        if (!data.success) {
            console.error('Failed to fetch processes');

        }
    }

    useEffect(() => {
        getProcess();
    }
        , []);

    const handleGetSteps = async (id, name) => {
        const token = localStorage.getItem('token');

        console.log('Getting steps for process:', id);

        setOpenSteps(true);
        setNameProcess(name);
        setProcessId(id);

        try {
            const response = await fetch(`https://api.insightos.co.uk/api/getsteps/${id}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
                credentials: 'include',
            });

            const data = await response.json();

            if (response.ok && data.success) {
                console.log('Steps:', data.data);


                // push the ProcessId to the steps array


setTrainingDocuments(data.training);
                setTrainingFinished(data.trainingFinished || false);

                setSteps(data.data);  // ✅ Fix: Use `data.tasks`
            } else {
                console.error('Failed to fetch steps:', data.message);
                alert(data.message || "Error fetching tasks.");
            }

        } catch (error) {
            console.error('Error fetching steps:', error);
        }
    };


    useEffect(() => {

        const getAllRoles = async () => {

            const token = localStorage.getItem('token');

            const response = await fetch('https://api.insightos.co.uk/api/allroles', {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
                credentials : 'include',
            });

            const data = await response.json();

            if (data.success) {
                console.log('Roles:', data.data);
                setGetRoles(data.data);
            }


            if (!data.success) {
                console.error('Failed to fetch roles');
            }

        }

        getAllRoles();

    }, [openTaskForm]);

    useEffect(() => {
        const fetchData = async () => {
            const response = await fetch("https://api.insightos.co.uk/api/allroles", {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                },
                credentials: "include",
            });

            const data = await response.json();

            // Collect all unique tasks from all roles, splitting comma-separated strings into arrays
            const allTasks = Array.from(
                new Set(
                    (data.data || [])
                        .map(role => role.Tasks)
                        .flat()
                        .filter(Boolean)
                        .map(taskStr =>
                            typeof taskStr === "string"
                                ? taskStr.split(",").map(t => t.trim())
                                : []
                        )
                        .flat()
                        .filter(Boolean)
                )
            );

            // Find tasks in allTasks that are NOT in processNames
            const unmatchedTasks = allTasks.filter(
                task => !processNames.includes(task)
            );

            setUnmatched(unmatchedTasks);

            console.log("All Tasks:", allTasks);
            console.log("Process Names:", processNames);
            console.log("Unmatched Tasks:", unmatchedTasks);
        };

        fetchData();
    }, [processNames]);

    const handleSaveTask = async (event) => {
        event.preventDefault(); // Prevent page reload

        
    
        const token = localStorage.getItem('token');
    
        try {
            const response = await fetch('https://api.insightos.co.uk/api/addsteps', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json',
               },
               credentials : 'include',
            body: JSON.stringify({
                task: taskName,
                description: taskDescription,
                step: stepNumber,
                role: role,
                processId: processId,
            }),
        });
    
        const data = await response.json();
    
        if (data.success) {
            console.log('Task created successfully');

// send the data.data to OpenSubStepsCreator

setOpenSubStepsCreator(data.data);


            setOpenTaskForm(false);
            handleGetSteps(processId, nameProcess);
        }
        
    
    } catch (error) {
        console.error('Failed to create task:', error);
    }

    };



    const handleEditTask = async (event) => {

        event.preventDefault(); // Prevent page reload

        const token = localStorage.getItem('token');

        try {
            const response = await fetch('https://api.insightos.co.uk/api/editsteps', {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                },
                credentials : 'include',
                body: JSON.stringify({
                    taskId: taskID,
                    task: taskName,
                    description: taskDescription,
                    step: stepNumber,
                    role: role,
                    processId: processId,
                }),

            });

            const data = await response.json();

            if (data.success) {
                console.log('Task edited successfully');
                setOpenEditTaskForm(false);
                handleGetSteps(processId, nameProcess);
            }

        } catch (error) {
            console.error('Failed to edit task:', error);
        }

    };



const handleDeleteTask = async (id) => {
    const token = localStorage.getItem('token');

    try {
        const response = await fetch(`https://api.insightos.co.uk/api/deletesteps/${id}`, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
            },
            credentials : 'include',

        });

        if (!response.ok) throw new Error('Failed to delete task');

        handleGetSteps(processId, nameProcess);

    } catch (error) {
        console.error('Error deleting task:', error);
    }

};


const handleEditProcess = async (e) => {
    e.preventDefault();

    const token = localStorage.getItem('token');

    try {
        const response = await fetch(`https://api.insightos.co.uk/api/editprocess/${processId}`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
            },
            credentials : 'include',

            body: JSON.stringify({
                Name: processName,
                Description: processDescription,
            }),
        });

        const data = await response.json();

        if (data.success) {
            console.log('Process edited successfully');
            setEditOpenProcessForm(false);
            getProcess();
        }

    } catch (error) {
        console.error('Error editing process:', error);
    }

};


const handleProcessDelete = async (id) => {

    const token = localStorage.getItem('token');

    try {

        const response = await fetch(`https://api.insightos.co.uk/api/deleteprocess/${id}`, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
            },
            credentials : 'include',


        });

        if (!response.ok) throw new Error('Failed to delete process');

        getProcess();

    } catch (error) {
        console.error('Error deleting process:', error);
    }

};


const handleChangeRole = async (taskId, newRole) => {
    try {
        const response = await fetch(`https://api.insightos.co.uk/api/updatetaskrole/${taskId}`, {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json' },
            credentials: 'include',
            body: JSON.stringify({ role: newRole }),
        });
        const data = await response.json();
        if (data.success) {
            setOpenRoleDropdown(null);
            handleGetSteps(processId, nameProcess);
        }
    } catch (error) {
        console.error('Failed to change role:', error);
    }
};


const handleAiGenerate = async () => {
    setLoading(true);

    try {
        const response = await fetch('https://api.insightos.co.uk/api/aigenerateprocess', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            credentials : 'include',

            body: JSON.stringify({
                process: processName,
                description: processDescription,
                valueEngine: valueEngine,
                estimatedTime : estimatedTime
            }),
        });

        const data = await response.json();

        if (response.status === 202 && data.queued && data.jobId) {
            navigate(`/job-progress/${data.jobId}`, {
                state: {
                    title: 'Generating process structure',
                    successPath: '/process-creator',
                    backPath: '/process-creator',
                },
            });
            return;
        }

        if (data.success) {
            console.log('AI Generated successfully');
            window.location.reload();
            setLoading(false);
        }

    } catch (error) {
        console.error('Error generating AI:', error);
    }

};




if (openAiGenerate) {
    return (
        <ProcessDocBuilder info={openAiGenerate.processId} name={processName} role={openAiGenerate.role} />
    )
}


if (openTrainingViewer) {
    return (
        <CourseViewer courseDocName={openTrainingViewer} />
    )
}

    return (
        <>
            <div>
                {loading && (
                    <Loading />
                )}

                <div className="flex h-screen">
                    {/* Sidebar (Fixed for Desktop) */}
                    <div className="hidden lg:flex lg:flex-col lg:w-[80px] lg:fixed lg:inset-y-0 lg:left-0 lg:z-50 lg:bg-gradient-to-b from-indigo-900 via-sky-500 to-emerald-500 lg:pb-4 overflow-y-auto">
                        <div className="flex h-16 items-center justify-center">
                            <img alt="Logo" src="/2.png" className="h-10 w-auto rounded-full" />
                        </div>
                        <nav className="mt-8 flex flex-col items-center space-y-1">
                            {navigation.map((item) => (
                                <div key={item.name} className="relative">
                                    <Link
                                        to={item.href}
                                        className={`group flex items-center justify-center p-3 rounded-md ${item.current ? "bg-white text-blue-700" : "text-white hover:bg-blue-700"
                                            }`}
                                    >
                                        <item.icon className="h-6 w-6" />
                                        <span className="absolute center-full ml-2 scale-0 bg-gray-700 px-2 py-1 text-xs text-white rounded-md transition-transform group-hover:scale-100">
                                            {item.name}
                                        </span>
                                    </Link>
                                </div>
                            ))}
                        </nav>
                    </div>

                    {/* Sidebar (Mobile - Dialog) */}
                    <Dialog open={sidebarOpen} onClose={setSidebarOpen} className="lg:hidden">
                        <DialogBackdrop className="fixed inset-0 bg-white opacity-75 transition-opacity" />
                        <div className="fixed inset-0 flex">
                            <DialogPanel className="w-full max-w-xs transform transition-all duration-300">
                                <div className="bg-gradient-to-b from-indigo-900 via-sky-500 to-emerald-500 p-6">
                                    <div className="flex justify-between items-center">
                                        <img alt="Logo" src="/1.png" className="h-8 rounded-full" />
                                        <button onClick={() => setSidebarOpen(false)}>
                                            <XMarkIcon className="h-6 w-6 text-white" />
                                        </button>
                                    </div>
                                    <nav className="mt-8">
                                        <ul className="space-y-2">
                                            {navigation.map((item) => (
                                                <li key={item.name}>
                                                    <Link
                                                        to={item.href}
                                                        className="flex items-center text-white hover:bg-blue-700 p-3 rounded-md"
                                                    >
                                                        <item.icon className="h-6 w-6" />
                                                        <span className="ml-3">{item.name}</span>
                                                    </Link>
                                                </li>
                                            ))}
                                        </ul>
                                    </nav>
                                </div>
                            </DialogPanel>
                        </div>
                    </Dialog>

                    {/* Main Content Wrapper */}
                    <div className="flex flex-1 flex-col lg:ml-[80px] overflow-y-auto">
                        {/* Top Navbar (Mobile Only) */}
                        <div className="sticky top-0 z-40 flex items-center bg-gradient-to-l from-indigo-900 via-sky-500 to-emerald-500 px-4 py-4 shadow-sm lg:hidden">
                            <button onClick={() => setSidebarOpen(true)} className="text-white">
                                <Bars3Icon className="h-6 w-6" />
                            </button>
                            <div className="flex-1 ml-3 text-white font-semibold">Dashboard</div>
                            <img src="/2.png" className="h-10 w-10 rounded-full" />
                        </div>

                        {/* Content Layout */}
                        

                        <div className="flex h-full flex-col lg:flex-row">
                            {/* Sidebar for Extra Features - Hidden on mobile when viewing steps */}
                            <div className={`${openSteps ? 'hidden lg:block' : 'block'} w-full lg:w-1/3 xl:w-1/3 border-r border-gray-200 p-4 lg:p-6 ${openProcessForm ? 'hidden lg:block' : ''}`}>
                                <div className="flex flex-col items-center space-y-4">
                                    <button onClick={() => setOpenProcessForm(true)}
                                        type="button"
                                        data-component="process-creator-sidebar"
                                        data-feature="open_process_form"
                                        className="w-full lg:w-auto inline-flex items-center justify-center gap-x-2 rounded-md bg-indigo-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                                    >
                                        Create New Process        <CheckCircleIcon aria-hidden="true" className="-mr-0.5 size-5" />
                                    </button>
                                </div>
                                {!openSubstepViewer && (
                                    <nav aria-label="Directory" className="h-full overflow-y-auto mt-5">
    {Object.keys(directory)
        .sort() // Sorts the keys alphabetically
        .map((letter) => (
            <div key={letter} className="relative">
                <div className="bg-gray-50 px-3 py-1.5 text-sm/6 font-semibold text-gray-900">
                    <h3>{letter}</h3>
                </div>
                {directory[letter].map((person) => (
                    <div 
                        key={person.id}
                        className="w-full flex flex-col lg:flex-row justify-between items-start lg:items-center mt-3 px-3 py-4 bg-emerald-500 rounded-lg shadow-md text-left space-y-2 lg:space-y-0"
                    >
                        <div className="min-w-0 flex-1 w-full lg:w-auto">
                            <p className="text-sm font-semibold text-white">{person.Name}</p>
                            <p className="mt-1 text-xs text-white line-clamp-2 lg:truncate">{person.Description}</p>
                            <p className="mt-1 text-xs text-white">{person.StaffName}</p>
                        </div>

                        {/* Buttons container */}
                        <div className="flex flex-wrap gap-2 items-center w-full lg:w-auto justify-start lg:justify-end">
                            {/* Edit Button */}
                            <button className="flex-1 lg:flex-none px-3 py-2 bg-blue-500 hover:bg-blue-700 text-white text-sm rounded-lg"
                                onClick={() => {
                                    setEditOpenProcessForm(true);
                                    setProcessName(person.Name);
                                    setProcessDescription(person.Description);
                                    setProcessId(person.id);
                                }} 
                                data-component="process-creator-directory"
                                data-feature="edit_process_entry"
                                data-process-id={person.id}
                            >
                                Edit
                            </button>

                            {/* Delete Button */}
                            <button 
                                onClick={() => handleProcessDelete(person.id)}
                                className="flex-1 lg:flex-none px-3 py-2 bg-red-500 hover:bg-red-700 text-white text-sm rounded-lg"
                                data-component="process-creator-directory"
                                data-feature="delete_process_entry"
                                data-process-id={person.id}
                            >
                                Delete
                            </button>

                            {/* Chevron Button */}
                            <button 
                                onClick={() => handleGetSteps(person.id, person.Name)}
                                className="flex-1 lg:flex-none flex items-center justify-center px-3 py-2 bg-gray-700 hover:bg-gray-800 text-white text-sm rounded-lg"
                                data-component="process-creator-directory"
                                data-feature="view_process_steps"
                                data-process-id={person.id}
                            >
                                <ChevronDoubleRightIcon className="w-5 h-5" />
                                <span className="ml-1 lg:hidden">View</span>
                            </button>
                        </div>
                    </div>
                ))}
            </div>
        ))}
</nav>

                                )}
                                {openSubstepViewer && (
                                    <Viewsubsteps taskData={openSubstepViewer} 
                                    
                                    
                                    />
                                )}



                            



</div>

{openSubStepsCreator && (
                                <div className="w-full lg:w-2/3 xl:w-2/3  overflow-y-auto p-4 lg:p-6 min-w-0 max-h-screen">

   <SubstepCreator 
    taskData={openSubStepsCreator}  
    processId={processId} 
    setOpenSubstepCreator={setOpenSubStepsCreator} 
    handleGetStep={handleGetSteps}
    setOpenSubstepViewer={setOpenSubstepViewer}  // ← add this
/>
    </div>
)}

                            {/* Main Content */}
                            {!openSubStepsCreator && (

                            <div className={`${openSteps ? 'w-full' : openProcessForm ? 'w-full' : 'w-full lg:w-2/3 xl:w-2/3'} overflow-y-auto p-4 lg:p-6 min-w-0 ${openProcessForm ? 'min-h-screen lg:max-h-screen' : 'max-h-screen'}`}>
                                {editOpenProcessForm && (
                                    <form onSubmit={handleEditProcess}>
                                        <div className="space-y-12">
                                            <div className="border-b border-gray-900/10 pb-12">
                                                <h2 className="text-base/7 font-semibold text-gray-900">Process</h2>
                                                <p className="mt-1 text-sm/6 text-gray-600">
                                                    Create a new process for the organization.
                                                </p>
                                               

                                                <div className="mt-10 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">
                                                    <div className="sm:col-span-4">
                                                        <label htmlFor="processName" className="block text-sm/6 font-medium text-gray-900">
                                                            Name
                                                        </label>
                                                        <div className="mt-2">
                                                            <div className="flex items-center rounded-md bg-white pl-3 outline outline-1 -outline-offset-1 outline-gray-300 focus-within:outline focus-within:outline-2 focus-within:-outline-offset-2 focus-within:outline-indigo-600">
                                                                <input
                                                                    onChange={(e) => setProcessName(e.target.value)}
                                                                    id="processName"
                                                                    value={processName}
                                                                    name="processName"
                                                                    type="text"
                                                                    placeholder="Facebook Campaign"
                                                                    className="block min-w-0 grow py-1.5 pl-1 pr-3 text-base text-gray-900 placeholder:text-gray-400 focus:outline focus:outline-0 sm:text-sm/6"
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="col-span-full">
                                                        <label htmlFor="about" className="block text-sm/6 font-medium text-gray-900">
                                                            Description
                                                        </label>
                                                        <div className="mt-2">
                                                            <textarea
                                                                onChange={(e) => setProcessDescription(e.target.value)}
                                                                id="about"
                                                                value={processDescription}
                                                                name="about"
                                                                rows={3}
                                                                className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6"
                                                                defaultValue={''}
                                                            />
                                                        </div>
                                                    </div>
                                                    <button 
                                                        type="submit" 
                                                        className="w-full sm:w-auto inline-flex items-center justify-center gap-x-2 rounded-md bg-emerald-500 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 touch-manipulation select-none"
                                                        style={{ minHeight: '44px' }}
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            e.stopPropagation();
                                                        }}
                                                        onTouchEnd={(e) => {
                                                            e.preventDefault();
                                                            e.stopPropagation();
                                                        }}
                                                    >
                                                        Create Process
                                                        <CheckCircleIcon aria-hidden="true" className="-mr-0.5 size-5" />
                                                    </button>





                                                </div>
                                            </div>
                                        </div>
                                    </form>

                                )}
                                {openProcessForm && (
                                    <div className="w-full min-h-screen lg:min-h-0">
                                        <div className="space-y-6 lg:space-y-12 p-2 lg:p-0">
                                            <div className="border-b border-gray-900/10 pb-6 lg:pb-12">
                                                <div className="flex flex-col space-y-2 lg:space-y-0 lg:flex-row lg:items-center lg:justify-between mb-4">
                                                    <h2 className="text-lg lg:text-base font-semibold text-gray-900">Process</h2>
                                                    <div className="flex flex-wrap gap-2">
                                                        <button onClick={() => setOpenProcessForm(false)}
                                                            type="button"
                                                            data-component="process-creator-form"
                                                            data-feature="close_process_form"
                                                            className="flex-1 lg:flex-none inline-flex items-center justify-center gap-x-2 rounded-md bg-red-500 px-2.5 py-1.5 text-xs font-semibold text-white shadow-sm hover:bg-red-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                                                        >
                                                            Close Process Form
                                                            <XCircleIcon aria-hidden="true" className="-mr-0.5 size-4" />
                                                        </button>
                                                        {!showHelp && (
                                                            <button onClick={() => setShowHelp(true)}
                                                                type="button"
                                                                data-component="process-creator-form"
                                                                data-feature="show_process_help"
                                                                className="flex-1 lg:flex-none inline-flex items-center justify-center gap-x-2 rounded-md bg-blue-500 px-2.5 py-1.5 text-xs font-semibold text-white shadow-sm hover:bg-blue-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                                                            >
                                                                Show Help
                                                                <QuestionMarkCircleIcon aria-hidden="true" className="-mr-0.5 size-4" />
                                                            </button>
                                                        )}
                                                        {showHelp && (
                                                            <button onClick={() => setShowHelp(false)}
                                                                type="button"
                                                                data-component="process-creator-form"
                                                                data-feature="hide_process_help"
                                                                className="flex-1 lg:flex-none inline-flex items-center justify-center gap-x-2 rounded-md bg-red-500 px-2.5 py-1.5 text-xs font-semibold text-white shadow-sm hover:bg-blue-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                                                            >
                                                                Hide Help
                                                                <QuestionMarkCircleIcon aria-hidden="true" className="-mr-0.5 size-4" />
                                                            </button>
                                                        )}
                                                    </div>
                                                </div>


{showHelp && (
                                               <div className="space-y-6 p-6">
                                               <h2 className="text-2xl font-semibold text-gray-900">
                                                 Value Engines in the Context of Business Departments
                                               </h2>
                                         
                                               <div>
                                                 <h3 className="text-xl font-semibold text-gray-800">1. Growth Engine 🚀</h3>
                                                 <p className="text-gray-600">
                                                   The Growth Engine is about scaling, increasing revenue, and finding new opportunities. It’s often about going fast,
                                                   innovating, and acquiring new customers or market share. Different departments in a business focus on this engine in
                                                   unique ways:
                                                 </p>
                                                 <ul className="list-disc pl-6 space-y-2">
                                                   <li>
                                                     <strong>Sales:</strong> For sales, the Growth Engine means identifying new customer segments, expanding into new
                                                     markets, and driving revenue growth through strong sales strategies and new client acquisition.
                                                   </li>
                                                   <li>
                                                     <strong>Marketing:</strong> Marketing focuses on building brand awareness, running campaigns, and using performance
                                                     marketing strategies (e.g., digital ads, social media) to generate leads and boost customer engagement.
                                                   </li>
                                                   <li>
                                                     <strong>Customer Service:</strong> The Growth Engine in customer service means focusing on enhancing the customer
                                                     experience, solving issues faster, and maintaining a strong customer base that drives repeat business.
                                                   </li>
                                                   <li>
                                                     <strong>Development:</strong> For development teams, it translates to rapid feature rollouts, improving scalability
                                                     of the product, and adding new capabilities that attract more users or customers.
                                                   </li>
                                                 </ul>
                                               </div>
                                         
                                               <div>
                                                 <h3 className="text-xl font-semibold text-gray-800">2. Fulfillment Engine ✅</h3>
                                                 <p className="text-gray-600">
                                                   The Fulfillment Engine ensures everything operates smoothly, consistently, and reliably. It’s about delivering what
                                                   has been promised, whether it’s the product, service, or customer experience. This engine is critical for maintaining
                                                   stability and ensuring operations don’t get bogged down. Different teams contribute to it:
                                                 </p>
                                                 <ul className="list-disc pl-6 space-y-2">
                                                   <li>
                                                     <strong>Sales:</strong> Sales focuses on post-sale fulfillment, ensuring clients receive what they were promised
                                                     and addressing any issues that arise in the process.
                                                   </li>
                                                   <li>
                                                     <strong>Marketing:</strong> From a marketing perspective, the Fulfillment Engine ensures that customer expectations
                                                     are met through accurate messaging, delivered promises, and seamless experiences.
                                                   </li>
                                                   <li>
                                                     <strong>Customer Service:</strong> Customer service directly drives this engine by ensuring that any post-purchase
                                                     issues are resolved swiftly, providing ongoing support, and ensuring customer satisfaction.
                                                   </li>
                                                   <li>
                                                     <strong>Development:</strong> Development ensures that the systems and infrastructure that support the company’s
                                                     product or service are working smoothly, that bugs are fixed, and that the technology stack supports the growing
                                                     customer base.
                                                   </li>
                                                 </ul>
                                               </div>
                                         
                                               <div>
                                                 <h3 className="text-xl font-semibold text-gray-800">3. Innovation Engine 💡</h3>
                                                 <p className="text-gray-600">
                                                   The Innovation Engine is about introducing new ideas, processes, or technologies to stay ahead of the curve and
                                                   maintain a competitive edge. It’s about R&D, strategic planning, and constantly adapting to market demands. Each
                                                   department contributes to innovation in its own way:
                                                 </p>
                                                 <ul className="list-disc pl-6 space-y-2">
                                                   <li>
                                                     <strong>Sales:</strong> Sales teams innovate by finding new sales techniques, developing creative strategies, and
                                                     finding new ways to close deals and engage with customers.
                                                   </li>
                                                   <li>
                                                     <strong>Marketing:</strong> Marketing teams innovate with new campaigns, using AI, data analytics, and customer
                                                     behavior insights to refine targeting and engagement strategies.
                                                   </li>
                                                   <li>
                                                     <strong>Customer Service:</strong> For customer service, innovation could involve implementing new technologies
                                                     such as chatbots, AI-powered self-service portals, or customer engagement tools to improve service delivery.
                                                   </li>
                                                   <li>
                                                     <strong>Development:</strong> The development team constantly innovates by building new features, leveraging new
                                                     technologies (like AI, blockchain, etc.), and enhancing the product’s capabilities based on customer feedback and
                                                     emerging trends.
                                                   </li>
                                                 </ul>
                                               </div>
                                         
                                               <div>
                                                 <h3 className="text-xl font-semibold text-gray-800">How Each Department Aligns with the Engines</h3>
                                                 <p className="text-gray-600">
                                                   Each department in the company plays a crucial role in aligning its activities with one or more of the Value Engines.
                                                   The key is to recognize that these engines aren't isolated. They interact in various ways, and each department’s focus
                                                   on one engine supports the others:
                                                 </p>
                                                 <ul className="list-disc pl-6 space-y-2">
                                                   <li>
                                                     <strong>Sales & Growth Engine 🚀:</strong> Sales teams are directly aligned with the Growth Engine. Their primary
                                                     goal is to drive revenue by acquiring new clients, expanding accounts, and building long-term relationships.
                                                   </li>
                                                   <li>
                                                     <strong>Marketing & Growth & Innovation Engines 📈💡:</strong> Marketing teams drive the awareness and demand
                                                     generation that fuels the Growth Engine. They create campaigns and promotions that push new leads into the sales
                                                     pipeline. They also innovate with new ways to engage customers.
                                                   </li>
                                                   <li>
                                                     <strong>Customer Service & Fulfillment Engine ✅:</strong> Customer service directly supports the Fulfillment Engine.
                                                     Their job is to ensure that products or services delivered meet or exceed customer expectations and that issues are
                                                     resolved swiftly.
                                                   </li>
                                                   <li>
                                                     <strong>Development & All Engines 🚀✅💡:</strong> Development teams contribute to the Growth Engine by creating
                                                     products that scale, improving user experience, and continuously rolling out new features. They also ensure that
                                                     systems are stable for fulfillment and innovate by building new features.
                                                   </li>
                                                 </ul>
                                               </div>
                                         
                                               <div>
                                                 <h3 className="text-xl font-semibold text-gray-800">Bringing It All Together</h3>
                                                 <p className="text-gray-600">
                                                   Each department in the company plays a crucial role in aligning its activities with one or more of the Value Engines.
                                                   By recognizing these engines in all aspects of the business, companies can ensure they align their efforts in a way
                                                   that supports overall growth, stability, and long-term innovation. Each department’s alignment with these engines helps
                                                   create a harmonious workflow that accelerates performance and drives business success.
                                                 </p>
                                               </div>
                                             </div>
)}

                                                <div className="mt-10 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">
                                                    <div className="sm:col-span-4">
                                                        <p className="text-sm text-gray-600">
                                                            For each responsibility, for each role, please create an associated process below.
                                                        </p>
                                                         <div className="mt-2">
                                                   {unmatched.length > 0 && (
                                                    <div className="text-sm text-red-600">
                                                        <p className="mb-2">The following tasks are not matched:</p>
                                                        <div className="flex flex-wrap gap-2">
                                                            {unmatched.map((task) => (
                                                                <button 
                                                                    key={task}
                                                                    className='px-2 py-1 bg-red-200 rounded-lg hover:bg-emerald-500 hover:text-white text-xs sm:text-sm' 
                                                                    onClick={() => setProcessName(task)}
                                                                >
                                                                    {task}
                                                                </button>
                                                            ))}
                                                        </div>
                                                    </div>
                                                   )}
                                                </div>
                                                        <label htmlFor="processName" className="block text-sm/6 font-medium text-gray-900">
                                                            Name
                                                        </label>
                                                        <div className="mt-2">
                                                            <div className="flex items-center rounded-md bg-white pl-3 outline outline-1 -outline-offset-1 outline-gray-300 focus-within:outline focus-within:outline-2 focus-within:-outline-offset-2 focus-within:outline-indigo-600">
                                                                <input
                                                                    onChange={(e) => setProcessName(e.target.value)}
                                                                    id="processName"
                                                                    name="processName"
                                                                    value={processName}
                                                                    type="text"
                                                                    placeholder="Facebook Campaign"
                                                                    className="block min-w-0 grow py-1.5 pl-1 pr-3 text-base text-gray-900 placeholder:text-gray-400 focus:outline focus:outline-0 sm:text-sm/6"
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="col-span-full">
                                                        <label htmlFor="processDescription" className="block text-sm/6 font-medium text-gray-900">
                                                            Description
                                                        </label>
                                                        <div className="mt-2">
                                                            <textarea
                                                                onChange={(e) => setProcessDescription(e.target.value)}
                                                                id="processDescription"
                                                                name="processDescription"
                                                                value={processDescription}
                                                                rows={3}
                                                                className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6"
                                                                defaultValue={''}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="sm:col-span-4">
                                                        <label htmlFor="estimatedTime" className="block text-sm/6 font-medium text-gray-900">
                                                            Estimated Time (in hours)
                                                    </label>
                                                        <div className="mt-2">
                                                            <div className="flex items-center rounded-md bg-white pl-3 outline outline-1 -outline-offset-1 outline-gray-300 focus-within:outline focus-within:outline-2 focus-within:-outline-offset-2 focus-within:outline-indigo-600">
                                                                <input
                                                                    onChange={(e) => setEstimatedTime(e.target.value)}
                                                                    id="estimatedTime"
                                                                    name="estimatedTime"
                                                                    type="number"
                                                                    value={estimatedTime}
                                                                    placeholder="8"
                                                                    className="block min-w-0 grow py-1.5 pl-1 pr-3 text-base text-gray-900 placeholder:text-gray-400 focus:outline focus:outline-0 sm:text-sm/6"
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-span-full">
                                                        <label htmlFor="valueEngine" className="block text-sm/6 font-medium text-gray-900">
                                                            Value Engine
                                                        </label>
                                                        <div className="mt-2">
                                                            <select
                                                                onChange={(e) => setValueEngine(e.target.value)}
                                                                id="valueEngine"
                                                                name="valueEngine"
                                                                value={valueEngine}
                                                                className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6"
                                                            >
                                                                <option value="growth">Growth Engine</option>
                                                                <option value="fulfillment">Fulfillment Engine</option>
                                                                <option value="innovation">Innovation Engine</option>
                                                            </select>
                                                        </div>
                                                    </div>

                                                    <div className="col-span-full flex flex-col sm:flex-row gap-4">
                                                        <button 
                                                            type="submit" 
                                                            onClick={(e) => {
                                                                e.preventDefault();
                                                                e.stopPropagation();
                                                                handleSubmitNewProcess(e);
                                                            }}
                                                            onTouchEnd={(e) => {
                                                                e.preventDefault();
                                                                e.stopPropagation();
                                                                handleSubmitNewProcess(e);
                                                            }}
                                                            data-component="process-creator-form"
                                                            data-feature="create_process_post"
                                                            data-process-name={processName || undefined}
                                                            className="w-full sm:w-auto inline-flex items-center justify-center gap-x-2 rounded-md bg-emerald-500 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 touch-manipulation select-none"
                                                            style={{ minHeight: '44px' }}
                                                        >
                                                            Create Process
                                                            <CheckCircleIcon aria-hidden="true" className="-mr-0.5 size-5" />
                                                        </button>
                                                        <button onClick={handleAiGenerate}
                                                            type="button"
                                                            data-component="process-creator-form"
                                                            data-time-saved="300"
                                                            data-feature="ai_generate_process_post"
                                                            className="w-full sm:w-auto inline-flex items-center justify-center gap-x-2 rounded-md bg-indigo-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-red-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                                                        >
                                                            Generate Process
                                                            <Cog8ToothIcon aria-hidden="true" className="-mr-0.5 size-5" />
                                                        </button>
                                                    </div>






                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}
                                {openSteps && (
                                    <div className="w-full p-2 bg-white min-h-screen">
                                        <div className="flex flex-col lg:flex-row lg:justify-start lg:items-center mb-2 p-3 bg-indigo-600 rounded-lg space-y-2 lg:space-y-0 lg:space-x-4">
                                            <div className="flex items-center space-x-2 w-full lg:w-auto">
                                                {/* Mobile Back to Processes Button */}
                                                <button 
                                                    onClick={() => setOpenSteps(false)}
                                                    data-component="process-creator-steps"
                                                    data-feature="back_to_process_directory"
                                                    className="lg:hidden inline-flex items-center justify-center gap-x-2 rounded-md bg-gray-700 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-gray-600"
                                                >
                                                    <ChevronDoubleRightIcon className="w-4 h-4 rotate-180" />
                                                    Processes
                                                </button>
                                                <h2 className="text-base font-semibold text-white">{nameProcess}</h2>
                                            </div>
                                            <div className="flex flex-wrap gap-2">
                                                {!openTaskForm && (
                                                <button onClick={() => setOpenTaskForm(true)}
                                                    type="button"
                                                    data-component="process-creator-steps"
                                                    data-feature="open_task_form"
                                                    className="inline-flex items-center justify-center gap-x-2 rounded-md bg-emerald-500 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500"
                                                >
                                                    Add Task        <PlusCircleIcon aria-hidden="true" className="-mr-0.5 size-5" />
                                                </button>
                                                )}
                                                {openTaskForm && (
                                                    <button onClick={() => setOpenTaskForm(false)}
                                                    type="button"
                                                    data-component="process-creator-steps"
                                                    data-feature="close_task_form"
                                                    className="inline-flex items-center justify-center gap-x-2 rounded-md bg-red-500 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-red-600"
                                                >
                                                    Close Task Form        <XCircleIcon aria-hidden="true" className="-mr-0.5 size-5" />
                                                </button>   
                                                )}

                                                {!openTaskForm && (
                                                <button onClick={() => setOpenSteps(false)}
                                                    type="button"
                                                    data-component="process-creator-steps"
                                                    data-feature="close_process_steps"
                                                    className="hidden lg:inline-flex items-center justify-center gap-x-2 rounded-md bg-red-500 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500"
                                                >
                                                    Close
                                                    <XCircleIcon aria-hidden="true" className="-mr-0.5 size-5" />
                                                </button>
                                            )}
                                            {trainingDocuments === null && (
                                            <button onClick={() => setOpenAiGenerate({
                                                processId: steps[0]?.ProcessId,
                                                role: steps[0]?.Role
                                            })}
                                                type="button"
                                                data-component="process-creator-steps"
                                                data-time-saved = "720"
                                                data-feature="generate_training_doc"
                                                className="inline-flex items-center justify-center gap-x-2 rounded-md bg-yellow-500 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-emerald-600"
                                            >
                                                Generate Documents
                                                <DocumentIcon aria-hidden="true" className="-mr-0.5 size-5" />
                                            </button>
                                        )}
                                        {trainingDocuments !== null && !trainingFinished && (
                                            <button onClick={() => setOpenAiGenerate({
                                                processId: steps[0]?.ProcessId,
                                                role: steps[0]?.Role
                                            })}
                                                type="button"
                                                data-component="process-creator-steps"
                                                data-feature="continue_training_doc"
                                                className="inline-flex items-center justify-center gap-x-2 rounded-md bg-orange-500 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-orange-600"
                                            >
                                                Continue Generation
                                                <DocumentIcon aria-hidden="true" className="-mr-0.5 size-5" />
                                            </button>
                                        )}
                                        {trainingDocuments !== null && trainingFinished && (
                                            <button onClick={() => setOpenDoc(trainingDocuments)}
                                                type="button"
                                                data-component="process-creator-steps"
                                                data-feature="view_training_doc"
                                                className="inline-flex items-center justify-center gap-x-2 rounded-md bg-yellow-500 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-red-600"
                                            >
                                                View Document
                                                <DocumentIcon aria-hidden="true" className="-mr-0.5 size-5" />
                                            </button>
                                        )}
                                        <button 
                                            onClick={() => navigate('/trainingdoceditor', { state: { processId: steps[0]?.ProcessId, role: steps[0]?.Role, processName: nameProcess } })}
                                            type="button"
                                            data-component="process-creator-steps"
                                            data-feature="edit_documents_nav"
                                            className="inline-flex items-center justify-center gap-x-2 rounded-md bg-blue-500 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-blue-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                                        >
                                            Edit Documents
                                            <PencilIcon aria-hidden="true" className="-mr-0.5 size-5" />
                                        </button>
                                            </div>
                                        </div>

                                        {openTaskForm && (
                                            
                                            <div className="space-y-12">
                                                <div className="border-b border-gray-900/10 pb-12">
                                                    <h2 className="text-base/7 font-semibold text-gray-900">Task</h2>
                                                    <p className="mt-1 text-sm/6 text-gray-600">
                                                        Create An Hourly Task As Part Of The Process.
                                                    </p>

                                                    <div className="mt-10 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">
                                                        <div className="col-span-full sm:col-span-4">
                                                            <label htmlFor="taskName" className="block text-sm/6 font-medium text-gray-900">
                                                                Name
                                                            </label>
                                                            <div className="mt-2">
                                                                <div className="flex items-center rounded-md bg-white pl-3 outline outline-1 -outline-offset-1 outline-gray-300 focus-within:outline focus-within:outline-2 focus-within:-outline-offset-2 focus-within:outline-indigo-600">
                                                                    <input
                                                                        onChange={(e) => setTaskName(e.target.value)}
                                                                        id="taskName"
                                                                        value={taskName}
                                                                        name="taskName"
                                                                        type="text"
                                                                        placeholder="Facebook Campaign"
                                                                        className="block min-w-0 grow py-1.5 pl-1 pr-3 text-base text-gray-900 placeholder:text-gray-400 focus:outline focus:outline-0 sm:text-sm/6"
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className="col-span-full">
                                                            <label htmlFor="taskDescription" className="block text-sm/6 font-medium text-gray-900">
                                                                Description
                                                            </label>
                                                            <div className="mt-2">
                                                                <textarea
                                                                    onChange={(e) => setTaskDescription(e.target.value)}
                                                                    id="taskDescription"
                                                                    value={taskDescription}
                                                                    name="taskDescription"
                                                                    rows={3}
                                                                    className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6"
                                                                    defaultValue={''}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="col-span-full sm:col-span-3">
                                                            <label htmlFor="stepNumber" className="block text-sm/6 font-medium text-gray-900">
                                                                Step Number
                                                            </label>
                                                            <div className="mt-2">
                                                                <div className="flex items-center rounded-md bg-white pl-3 outline outline-1 -outline-offset-1 outline-gray-300 focus-within:outline focus-within:outline-2 focus-within:-outline-offset-2 focus-within:outline-indigo-600">
                                                                    <input
                                                                        onChange={(e) => setStepNumber(e.target.value)}
                                                                        id="stepNumber"
                                                                        name="stepNumber"
                                                                        value={stepNumber}
                                                                        type="number"
                                                                        placeholder="1"
                                                                        className="block min-w-0 grow py-1.5 pl-1 pr-3 text-base text-gray-900 placeholder:text-gray-400 focus:outline focus:outline-0 sm:text-sm/6"
                                                                    />

                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-span-full sm:col-span-3">
                                                            <label htmlFor="roles" className="block text-sm/6 font-medium text-gray-900">
                                                                Select Role
                                                            </label>
                                                            <div className="mt-2">
                                                                <select
                                                                    onChange={(e) => setRole(e.target.value)}
                                                                    id="roles"
                                                                    
                                                                    name="roles"
                                                                    className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6"
                                                                >
                                                                    <option value="">Select Role</option>
                                                                    {getRoles.map((role) => (
                                                                        <option key={role.id} value={role.Name}>
                                                                            {role.Name}
                                                                        </option>
                                                                    ))}
                                                                </select>
                                                            </div>

                                                        </div>

                                                       




                                                    </div>
                                                </div>
                                                <button onClick={handleSaveTask}
                                                    type="submit"
                                                    data-component="process-task-form"
                                                    data-feature="create_process_task_post"
                                                    data-process-id={processId || undefined}
                                                
                                                className="w-full sm:w-auto inline-flex justify-center items-center gap-x-2 rounded-md bg-emerald-500 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600">
                                                            Create Task
                                                            <CheckCircleIcon aria-hidden="true" className="-mr-0.5 size-5" />
                                                        </button>
                                                        
                                            </div>

                                        )}
                                        {openEditTaskForm && (
    <div className="space-y-12">
        <div className="border-b border-gray-900/10 pb-12">
        <button onClick={() => setOpenEditTaskForm(false)}
            type="button"
            data-component="process-task-edit"
            data-feature="close_edit_task_form"
            className="w-full sm:w-auto inline-flex items-center justify-center gap-x-2 rounded-md bg-red-500 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-red-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
        >
            Close
            <XCircleIcon aria-hidden="true" className="-mr-0.5 size-5" />
        </button>

            <h2 className="text-base/7 font-semibold text-gray-900 mt-4">Edit Task</h2>
            <p className="mt-1 text-sm/6 text-gray-600">
                Edit the task details below.
            </p>

            <div className="mt-10 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">
                <div className="col-span-full sm:col-span-4">
                    <label htmlFor="taskName" className="block text-sm/6 font-medium text-gray-900">
                        Name
                    </label>
                    <div className="mt-2">
                        <input
                            onChange={(e) => setTaskName(e.target.value)}
                            value={taskName}
                            id="taskName"
                            name="taskName"
                            type="text"
                            placeholder="Task Name"
                            className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600"
                        />
                    </div>
                </div>

                <div className="col-span-full">
                    <label htmlFor="taskDescription" className="block text-sm/6 font-medium text-gray-900">
                        Description
                    </label>
                    <div className="mt-2">
                        <textarea
                            onChange={(e) => setTaskDescription(e.target.value)}
                            value={taskDescription}
                            id="taskDescription"
                            name="taskDescription"
                            rows={3}
                            className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600"
                        />
                    </div>
                </div>

                <div className="col-span-full sm:col-span-3">
                    <label htmlFor="stepNumber" className="block text-sm/6 font-medium text-gray-900">
                        Step Number
                    </label>
                    <div className="mt-2">
                        <input
                            onChange={(e) => setStepNumber(e.target.value)}
                            value={stepNumber}
                            id="stepNumber"
                            name="stepNumber"
                            type="number"
                            placeholder="1"
                            className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600"
                        />
                    </div>
                </div>

                <div className="col-span-full sm:col-span-3">
                    <label htmlFor="roles" className="block text-sm/6 font-medium text-gray-900">
                        Select Role
                    </label>
                    <div className="mt-2">
                        <select
                            onChange={(e) => setRole(e.target.value)}
                            value={role}
                            id="roles"
                            name="roles"
                            className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600"
                        >
                            <option value="">Select Role</option>
                            {getRoles.map((roleOption) => (
                                <option key={roleOption.id} value={roleOption.Name}>
                                    {roleOption.Name}
                                </option>
                            ))}
                        </select>
                    </div>
                </div>
            </div>
        </div>

        <button onClick={handleEditTask}
            type="submit"
            data-component="process-task-edit"
            data-feature="update_process_task_put"
            data-task-id={taskID || undefined}
            className="w-full sm:w-auto inline-flex justify-center items-center gap-x-2 rounded-md bg-emerald-500 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500"
        >
            Edit Task
            <CheckCircleIcon aria-hidden="true" className="-mr-0.5 size-5" />
        </button>
    </div>
)}



                                        {/* Mobile Substep Viewer - Below header bar */}
                                        {openSubstepViewer && (
                                            <div className="lg:hidden mt-4 max-h-96 border rounded-lg bg-white shadow-sm">
                                                <Viewsubsteps taskData={openSubstepViewer} />
                                            </div>
                                        )}

                                        {/* Show tasks */}
                                        <div className="mt-4">
                                            {steps.length > 0 ? (
                                                <ul role="list" className="divide-y divide-gray-100 space-y-4">
                                                {steps.map((person) => (
                                                  <li key={person.id} className="flex flex-col lg:flex-row justify-between gap-x-6 py-5 bg-sky-100 rounded-md shadow-md">
                                                    <div className="flex flex-col lg:flex-row min-w-0 gap-x-4 w-full">
                                                    <div className="size-12 shadow-sm p-2 ml-2 mr-2 flex items-center justify-center rounded-full bg-sky-400 text-white font-semibold mx-auto lg:mx-0">
  {person.Step}
</div>


                                                      <div className="min-w-0 flex-auto text-center lg:text-left">
                                                        <p className="text-sm/6 font-semibold text-gray-900">{person.Task}</p>
                                                        <p className="mt-1 text-xs/5 text-gray-900">{person.Description}</p>
                                                        <p className="mt-1 text-xs/5 text-gray-900">Author: {person.StaffName}</p>
                                                        <div className="mt-2 flex flex-wrap gap-2 justify-center lg:justify-start">
    {(!openSubstepViewer || openSubstepViewer.id !== person.id) && (
        <button
            onClick={() => setOpenSubstepViewer(person)}
            type="button"
            data-component="process-task-list"
            data-feature="view_substeps"
            data-task-id={person.id}
            className="inline-flex items-center gap-x-1 rounded-md bg-sky-500 px-2.5 py-1.5 text-xs font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
        >
            View Sub-Steps
            <EyeIcon aria-hidden="true" className="-mr-0.5 size-4" />
        </button>
    )}
    {openSubstepViewer && openSubstepViewer.id === person.id && (
        <button
            onClick={() => setOpenSubstepViewer(false)}
            type="button"
            data-component="process-task-list"
            data-feature="close_substeps"
            data-task-id={person.id}
            className="inline-flex items-center gap-x-1 rounded-md bg-red-500 px-2.5 py-1.5 text-xs font-semibold text-white shadow-sm hover:bg-red-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
        >
            Close Sub-Steps
            <XCircleIcon aria-hidden="true" className="-mr-0.5 size-4" />
        </button>
    )}

    <button
        onClick={() => setOpenSubStepsCreator(person)}
        type="button"
        data-component="process-task-list"
        data-feature="open_substep_creator"
        data-task-id={person.id}
        className="inline-flex items-center gap-x-1 rounded-md bg-emerald-500 px-2.5 py-1.5 text-xs font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
    >
        Create SubSteps
        <EyeIcon aria-hidden="true" className="-mr-0.5 size-4" />
    </button>

    <button
    onClick={() => {
        setTaskName(person?.Task || '');
        setTaskDescription(person?.Description || '');
        setStepNumber(person?.Step || '');
        setRole(person?.Role || '');
        setOpenEditTaskForm(true);
        setTaskID(person.id);
    }}
    type="button"
    data-component="process-task-list"
    data-feature="open_edit_task_form"
    data-task-id={person.id}
    className="inline-flex items-center gap-x-1 rounded-md bg-orange-500 px-2.5 py-1.5 text-xs font-semibold text-white shadow-sm hover:bg-red-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
>
    Edit Task
    <PencilIcon aria-hidden="true" className="-mr-0.5 size-4" />
</button>


{!openSubstepViewer && (
    <button onClick={() => handleDeleteTask(person.id)}
        type="button"
        data-component="process-task-list"
        data-feature="delete_task_delete"
        data-task-id={person.id}
        className="inline-flex items-center gap-x-1 rounded-md bg-red-500 px-2.5 py-1.5 text-xs font-semibold text-white shadow-sm hover:bg-red-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
    >
        Delete Task
        <XCircleIcon aria-hidden="true" className="-mr-0.5 size-4" />
    </button>
)}
</div>


                                                      </div>
                                                    </div>
                                                    <div className="shrink-0 flex flex-col items-center lg:items-end mt-4 lg:mt-0">
                                                      <p className="text-sm/6 text-white p-2 bg-indigo-600 rounded-lg shadow-lg">{person.Role}</p>
                                                      <button className="mt-2 inline-flex items-center gap-x-1 rounded-md bg-gray-700 px-2.5 py-1.5 text-xs font-semibold text-white shadow-sm hover:bg-gray-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                                                        onClick={() => {setOpenRoleDropdown(person.id)}}
                                                        data-component="process-task-list"
                                                        data-feature="open_role_dropdown"
                                                        data-task-id={person.id}
                                                      >
                                                        Change Role
                                                        <UserIcon aria-hidden="true" className="-mr-0.5 size-4" />
                                                      </button>
                                                      {openRoleDropdown === person.id && (
                                                        <div className="mt-2 w-40 bg-white rounded-md shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none z-10 absolute">
                                                            <div className="py-1">
                                                                {getRoles.map((roleOption) => (
                                                                    <button
                                                                        key={roleOption.id}
                                                                        onClick={() => handleChangeRole(person.id, roleOption.Name)}
                                                                        className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                                                                        data-component="process-task-list"
                                                                        data-feature="select_new_role"
                                                                        data-task-id={person.id}
                                                                        data-role-id={roleOption.id}
                                                                    >
                                                                        {roleOption.Name}
                                                                    </button>
                                                                ))}
                                                            </div>
                                                        </div>
                                                        )}
                                                    </div>
                                                  </li>
                                                ))}
                                              </ul>
                                            ) : (
                                                <p className="text-sm text-gray-500 text-center">No Tasks In Process</p>
                                            )}
                                        </div>
                                    </div>
                                )}
                            </div>
                            )}








                        </div>
                        
                    </div>
                </div>
            </div>

        </>
    );
}
